export const SET_COMMON_CONFIG = "SET_COMMON_CONFIG"
export const SET_MULTI_COMMON_CONFIG = "SET_MULTI_COMMON_CONFIG"